export interface PurchaseOrderStockPriceApprovalSearchDto {
    page: number;
    limit: number;
    search?: string;
    sort?: string;
    sortDir?:  'ASC' | 'DESC';
    merchantId?: number;
    status?: 'pending' | 'approved';
}